import "./InfoTooltip.scss";

import React from "react";
import clsx from "clsx";

import Tooltip, { TooltipProps } from "../Tooltip/Tooltip";
import { IconInfo } from "../../../assets";

export interface InfoTooltipProps extends TooltipProps {
	children?: React.ReactNode;
}

const InfoTooltip = (props: InfoTooltipProps) => {
	const { className, children, ...otherProps } = props;

	return (
		<Tooltip
			className={clsx("InfoTooltip", "--pdf-ignore", className)}
			{...otherProps}
		>
			<IconInfo className={"InfoTooltip__reference"} />
			{children}
		</Tooltip>
	);
};

export default React.memo(InfoTooltip);
